import { content } from '../../config'
const { EMAIL, BRAND_NAME } = content

export const routes = {
	ADMIN: '/admin',
	PLANOS: '/planos',
	ENTRAR: '/entrar',
	CLIENTE: '/cliente',
	CADASTRO: '/cadastro',
	PARCEIRO: '/parceiro',
	REGULAMENTO: '/regulamento',
	BENEFITS: '/beneficios',
	ABOUT: '/sobre-nos',
	REBOOKING: '/remarcacao',
	INFO: '/informacoes-passageiros',
	ACCESSIBILITY: '/acessibilidade',
	FAQ: '/perguntas-frequentes',
	COMPRE_E_GANHE: '/compre-e-ganhe',
	SIMULADOR: '/minhas-compras',
	POLITICAS: '/politica-de-privacidade',
	COMPRA_DE_PONTOS: '/compra-de-pontos',
	CONVIDE_AMIGOS: '/convide-seus-amigos',
	COMPRA_DE_PASSAGEM: '/compra-de-passagem',
	PONTOS_PRESENTE: '/compra-de-pontos-presente',
	CONSULTA_DE_PASSAGEM: '/consulta-de-passagem',
	SOLICITACAO_DE_PONTOS: '/solicitacao-de-pontos',
	BLOG: 'https://planalto.com.br/site/blog/',
	PLANALTO_SITE: 'planalto.com.br',
	MUVICARD: '/muvicard',
	MEU_CARTAO: '/muvicard/meu-cartao',
	MUVICARD_CADASTRO: '/muvicard/cadastro',
	LOGIN_SOCIAL_CADASTRO: '/login-social/cadastro',
	MUVICARD_REGULAMENTO: '/muvicard/regulamento',
	MEU_CARTAO_REDEFINIR_SENHA: '/muvicard/meu-cartao/redefinir-senha',
	MEU_CARTAO_CANCELAR: '/muvicard/meu-cartao/cancelar-cartao',
	MUVIBUS: '/muvibus',
	WHATSAPP:
		'https://api.whatsapp.com/send?phone=555540207488&text=Ol%C3%A1%2C%20eu%20gostaria%20de%20comprar%20passagem!%20',
	ATENDIMENTO: `mailto:${EMAIL}?Subject=Fale conosco - ${BRAND_NAME} site`,
	ICONMYSHOPPING: '/minhas-compras',
	INSTITUCIONAL: 'https://institucional.planalto.com.br',
	LOJA: '/loja-muviflex',
	NOTA_FISCAL: '/nota-fiscal',
}
